import React, { useContext, useState } from "react";

const AssignmentReviewContext = React.createContext();
const SetAssignmentReviewContext = React.createContext();

export function useAssignmentReview() {
  return useContext(AssignmentReviewContext);
}

export function useSetAssignmentReview() {
  return useContext(SetAssignmentReviewContext);
}

export function AssignmentReviewProvider({ children }) {
  const [assignmentReview, setAssignmentReview] = useState({});

  return (
    <AssignmentReviewContext.Provider value={assignmentReview}>
      <SetAssignmentReviewContext.Provider value={setAssignmentReview}>
        {children}
      </SetAssignmentReviewContext.Provider>
    </AssignmentReviewContext.Provider>
  );
}
